import { type Job, type JobCreateInput } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Saves a new job as a Draft („Entwurf speichern"); the creator edits it
 * from `/jobs/:jobId/edit`. Sending it goes through `useSendJob`. */
export interface CreateJobInput {
  input: JobCreateInput;
}

export function useCreateJob(): UseMutationResult<Job, Error, CreateJobInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ input }) => client.createJob(input),
    onSuccess: (job) => {
      qc.invalidateQueries({ queryKey: ["jobs"] });
      qc.setQueryData(queryKeys.job(job.id), job);
    },
  });
}
